import { connect } from 'react-redux'

import ConcessionsCartSidebar from '../components/ConcessionsCartSidebar'
import { getTotal, hasCartItems2 } from '../selectors/cart'
import { getTipsEnabled, getStands, makeGetCurrentMenu  } from '../selectors/menus'
import { getDiscountsAvailable } from '../selectors/promotion'
import { getCashEnabled, getTicketEnabled, makeGetNoOpTenders } from '../selectors/revenueCenter'
import { menusSucceeded } from '../actions/menus'
import { clearCart } from '../actions/cart'
import { SIGNATURE_THRESHOLD_AMOUNT } from '../constants'
import { getSafMode } from '../selectors/appState'


const mapStateToProps = (state) => {
  const noOpTenders = makeGetNoOpTenders()(state)
  const cashEnabled = getCashEnabled(state)
  const tipsEnabled = getTipsEnabled(state)
  const total = getTotal(state)
  const threshHoldExceeded =  SIGNATURE_THRESHOLD_AMOUNT === 0 || (SIGNATURE_THRESHOLD_AMOUNT && total > SIGNATURE_THRESHOLD_AMOUNT)
  const signatureRequired = tipsEnabled || threshHoldExceeded
  const stands = getStands(state)
  const getMenu = makeGetCurrentMenu()
  const menu = getMenu(state)
  const tipSuggestions = menu?.tipSuggestions
  const safMode = getSafMode(state)
  const networkAvailable = (state?.config?.networkAvailable ?? false) && safMode !== 2
  const ticketEnabled = getTicketEnabled(state) && networkAvailable
  const discountsAvailable = getDiscountsAvailable(state) && state?.config?.networkAvailable

  return {
    hasCartItems: hasCartItems2(state),
    discountsAvailable,
    noOpTenders, 
    signatureRequired,
    stands,
    menu,
    tipSuggestions,
    cashEnabled,
    networkAvailable,
    ticketEnabled,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    clearCart: () => dispatch(clearCart()),
    setMenus: (stand, menu) => { dispatch(menusSucceeded({ data: {stands: [stand], menus: [menu]} })) }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(ConcessionsCartSidebar)
